// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"bde60ff3","168":"a966cfb4","219":"1590b8d8","538":"54340989","632":"b7fa6ad8"}[chunkId] + ".chunk.css";
};